import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import check from '@/assets/images/svg/check-icon.svg';
import { BaseDialog } from '@/components/shared/base-dialog';
import { RefundQueryParams } from '@/packages/subsidy/pages/refund-request/steps/resource-description/interfaces';

export interface ResourceApprovalCreatedDialogProps {
  onClose: () => void;
  resourceApprovalUuid: string;
  actionsVisibility?: {
    sendInvoice?: boolean;
    waitApproval?: boolean;
  };
}

export const ResourceApprovalCreatedDialog = ({
  actionsVisibility = {},
  resourceApprovalUuid,
  onClose,
}: ResourceApprovalCreatedDialogProps) => {
  const { sendInvoice = true, waitApproval = true } = actionsVisibility;
  const navigate = useNavigate();

  const handleRedirectToReceipts = () => {
    navigate(
      `/meus-reembolsos/solicitacao/${resourceApprovalUuid}?step=${RefundQueryParams.Invoice}`
    );
    onClose();
  };

  const handleRedirectToShow = () => {
    navigate(
      `/meus-reembolsos/solicitacao/${resourceApprovalUuid}?step=${RefundQueryParams.Description}`
    );
    onClose();
  };

  return (
    <BaseDialog
      open
      icon={<Box component="img" src={check} sx={{ width: 55 }} />}
      title="Item enviado para aprovação!"
      onClose={handleRedirectToShow}
    >
      <Stack gap={2} mb={3}>
        {waitApproval ? (
          <>
            <Typography>
              Assim que tivermos a resposta, informaremos por e-mail. Você
              também pode conferir o andamento na página de reembolsos.
            </Typography>
            <Box
              p={2}
              bgcolor="info.light"
              borderRadius={({ shape }) => `${shape.borderRadius}px`} //FIXME
            >
              <Typography>
                <strong>Já fez a compra? </strong>
                Se você já adquiriu o item, pode adiantar o processo enviando os
                comprovantes de compra e pagamento agora. Se não adquiriu ainda,
                sugerimos que aguarde a aprovação do item para ter certeza que
                poderá utilizar o reembolso.
              </Typography>
            </Box>
          </>
        ) : (
          <Typography>
            Você pode conferir o andamento da sua solicitação na página de
            reembolsos. Se você já adquiriu o item, pode adiantar o processo
            enviando os comprovantes de compra e pagamento agora.
          </Typography>
        )}
      </Stack>
      {sendInvoice && waitApproval ? (
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          gap={2}
          sx={{
            width: '100%',
            justifyContent: { xs: 'flex-start', md: 'flex-end' },
          }}
        >
          <Button
            onClick={handleRedirectToReceipts}
            sx={{ order: { xs: 0, md: 1 } }}
            variant="contained"
          >
            Enviar comprovantes
          </Button>
          <Button
            onClick={() => navigate('/meus-reembolsos')}
            variant="outlined"
          >
            Aguardar aprovação
          </Button>
        </Stack>
      ) : (
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          gap={2}
          sx={{
            width: '100%',
            justifyContent: { xs: 'flex-start', md: 'flex-end' },
          }}
        >
          <Button
            onClick={handleRedirectToShow}
            sx={{ order: { xs: 1, md: 0 } }}
          >
            Fechar
          </Button>
          <Button
            onClick={handleRedirectToReceipts}
            variant="contained"
            sx={{ order: { xs: 0, md: 1 } }}
          >
            Enviar comprovantes
          </Button>
        </Stack>
      )}
    </BaseDialog>
  );
};
